import { useState, useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';
import {
  IN_PRODUCT_HELP_ROUTE_GROUP,
  IN_PRODUCT_HELP_ROUTE_GROUP_NEW,
  routePaths,
  routeToRoutePathMapForInProductHelp,
} from '@css-xp/ppc-constants';

export const useInProductHelpRouteDetails = (
  isDesignIterationEnabled = false
): {
  routeGroup: string;
  routeName: string;
} => {
  const locationData = useLocation();
  const [routeName, setRouteName] = useState('');

  useEffect(() => {
    const pageName = Object.keys(routePaths).find((routeKey) =>
      matchPath(locationData.pathname, { path: routePaths[routeKey], exact: true })
    );
    if (pageName) {
      // @ts-ignore
      setRouteName(routeToRoutePathMapForInProductHelp[pageName] ?? 'home-page');
    } else {
      setRouteName('home-page');
    }
  }, [locationData.pathname]);

  return {
    routeGroup: isDesignIterationEnabled ? IN_PRODUCT_HELP_ROUTE_GROUP_NEW : IN_PRODUCT_HELP_ROUTE_GROUP,
    routeName,
  };
};
